import React, { useState } from 'react'
import FormField from '../../atoms/FormField/FormField'
import FormInput from '../../atoms/FormInput/FormInput'
import Button from '../../atoms/Button/Button'
import { Formik } from 'formik'
import Link from 'next/link'
import * as yup from 'yup'
import useTrans from '../../../hooks/useTrans'
import useSocialLogin, { CODE_ERROR_USER_NOT_ACTIVE } from '../../../hooks/useSocialLogin'
import { isGuestAllowed, isSocialLoginAllowed } from '../../../utils/servicegift'
import { useRouter } from 'next/router'
import { useSelector } from 'react-redux'

const validationSchema = yup.object({
  username: yup.string().required('il campo username è richiesto'),
  password: yup.string().required('Il campo password è richiesto'),
})

const LoginTemplateSg = ({ Login, CredentialError, ClosePopup }) => {
  const router = useRouter()
  const t = useTrans()
  const isAs400Down = useSelector((state) => state.servicegift.as400_down)
  const service_gift = useSelector((state) => state.servicegift?.service_gift)
  const login_text = useSelector((state) => state.logintext)
  const { FacebookLoginButton, GoogleLoginButton, error: errorSocialLogin } = useSocialLogin(
    service_gift,
    router.query?.next || '/'
  )

  const [error, setError] = useState(null)
  const isNextCheckout = router.query?.next?.includes('/cart/checkout') || false

  function createMArkup(testo) {
    return { __html: testo }
  }

  return (
    <div className={'page page--service_gift login_template_service_gift'}>
      <div className="w-container">
        <h1 className="page__title">
          {isNextCheckout ? t('Scegli come procedere al tuo acquisto') : t('Accedi o registrati')}
        </h1>
        {isAs400Down ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '40vh',
            }}
          >
            <h1>{t('Sito in manutenzione temporanea, riprova più tardi.')}</h1>
          </div>
        ) : (
          <div className="login_container">
            {isSocialLoginAllowed(service_gift) && (
              <div className="login__social__content">
                <p className="login__title">{t('Prosegui tramite Social')}</p>
                <div className="login__social__buttons">
                  <FacebookLoginButton />
                  <GoogleLoginButton />
                </div>
                {errorSocialLogin && <p className="login__social-error">{t(errorSocialLogin)}</p>}
              </div>
            )}
            <div className="login">
              <div className="login__content">
                <div className="login__sub-content">
                  <p className="login__title">{t('Accedi')}</p>
                  <p className="login__description">
                    {t(
                      'Accedi per visualizzare i prezzi per te, per controllare gli ordini e molto altro'
                    )}
                  </p>
                  <Formik
                    validationSchema={validationSchema}
                    initialValues={{
                      password: '',
                      username: '',
                    }}
                    onSubmit={({ username, password }) => {
                      const params = {
                        email: username,
                        password: password,
                      }
                      Login(params)
                        .then(() => setError(null))
                        .catch((err) => setError(err.message))
                    }}
                  >
                    {(props) => (
                      <>
                        <FormField
                          label="Username"
                          status={
                            props.touched.username && props.errors.username
                              ? 'error'
                              : props.touched.username && 'success'
                          }
                          errorMessage={props.errors.username}
                        >
                          <FormInput
                            value={props.values.username}
                            onChange={props.handleChange('username')}
                            onBlur={props.handleBlur('username')}
                          />
                        </FormField>

                        <FormField
                          label="Password"
                          status={
                            props.touched.password && props.errors.password
                              ? 'error'
                              : props.touched.password && 'success'
                          }
                          errorMessage={props.errors.password}
                        >
                          <FormInput
                            type="password"
                            value={props.values.password}
                            onChange={props.handleChange('password')}
                            onBlur={props.handleBlur('password')}
                          />
                        </FormField>
                        {error && <p style={{ color: 'red' }}>{error}</p>}
                        {CredentialError && (
                          <p style={{ color: 'red' }}>{t('Credenziali Errate')}</p>
                        )}

                        <Link href="/myaccount/recupera-password">
                          <a className="login__password-recovery">{t('Recupera la password')}</a>
                        </Link>

                        <Button
                          label="Accedi"
                          variant="primary"
                          size="medium"
                          onClick={() => props.handleSubmit()}
                          disabled={!props.isValid || !props.dirty}
                          className="login__button"
                        />
                      </>
                    )}
                  </Formik>
                </div>
              </div>
              <div className="login__content">
                {isGuestAllowed(service_gift) && isNextCheckout && (
                  <div className="login__sub-content">
                    <p className="login__title">{t('Acquista senza registrazione')}</p>
                    <p className="login__description">
                      {t(
                        'Rimani aggiornato sullo stato del tuo ordine e procedi con il tuo acquisto senza effettuare la registrazione.'
                      )}
                    </p>
                    <Button
                      label={t('Procedi senza registrazione')}
                      variant="primary"
                      size="medium"
                      href={`${router.query?.next}?guest=true`}
                      onClick={() => ClosePopup()}
                      className="login__button"
                    />
                  </div>
                )}
                <div className="login__sub-content">
                  <p className="login__title">{t('Registrati')}</p>
                  <div
                    className="login__description"
                    dangerouslySetInnerHTML={createMArkup(login_text?.login_text?.descrizione)}
                  >
                    {/* <p>{t(`${service_gift_text}Registrati per usufruire di tutti i vantaggi di Sipec`)}</p> */}
                    {/* <ul className="u-content-list">
        <li>{t(`${service_gift_text}Prezzi sempre aggiornati`)}</li>
        <li>{t(`${service_gift_text}Sempre la disponibilità reale degli articoli`)}</li>
        <li>
          {t("Potri inserire direttamente i tuoi ordini on-line (uno shop 24/24)")}
        </li>
        <li>
          {t("Potrai approfittare delle offere e consultare gli articoli fine serie e fuori catalogo")}
        </li>
      </ul> */}
                  </div>
                  <Button
                    label={t('Registrati')}
                    variant="secondary"
                    size="medium"
                    href={`/myaccount/registrazione${
                      router.query?.next ? '?next=' + router.query?.next : ''
                    }`}
                    onClick={() => ClosePopup()}
                    className="login__button"
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default LoginTemplateSg
